import { useTranslation } from 'next-i18next';
import cn from 'classnames';
import IconWrapper from '@components/ui/Icons';
import Tooltip from '@components/ui/Tooltip';

import styles from './BuyCanadian.module.scss';

const BuyCanadian = ({
  hit,
  isMadeInCanada,
  isCanadianBrand,
}: {
  hit?: boolean;
  isMadeInCanada?: boolean;
  isCanadianBrand?: boolean;
}) => {
  const { t } = useTranslation('common');

  return (
    <Tooltip
      tooltipId={`buy-canadian-tooltip-${
        isMadeInCanada ? 'made-in-canada' : 'canadian-brand'
      }`}
      tooltipContents={
        isMadeInCanada ? (
          <div
            dangerouslySetInnerHTML={{ __html: t('tooltip.madeInCanada') }}
          />
        ) : (
          <div
            dangerouslySetInnerHTML={{ __html: t('tooltip.canadianBrand') }}
          />
        )
      }
      popoverClasses={styles.tooltip}
      buttonClasses={styles.tooltipButton}
      openOnHover
    >
      <span
        className={cn(styles.container, {
          [styles.hit]: hit,
          [styles.canadianBrand]: isCanadianBrand,
        })}
      >
        <IconWrapper
          icon="maple-leaf"
          height={20}
          width={20}
          classNames={styles.mapleLeafIcon}
        />
      </span>
    </Tooltip>
  );
};

export default BuyCanadian;
